<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "TableDataImported",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.tableDataImported', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                tableName: this.$_.get(this.activity, 'payload.tableName'),
                successCount: this.$_.get(this.activity, 'payload.successCount', 0),
                recordCount: this.$_.get(this.activity, 'payload.recordCount', 0)
            });
        }
    }
};
</script>


